import AgentSettings from './AgentSettings';

export default AgentSettings;
